import { getShowValue } from "./getShowValue";
import FancyText from "./fancyText.vue";
import FileList from "./FileList.vue";

//值渲染组件
const ValueRender = {
    props: {
        info: {},
        value: {}
    },
    render(h) {

        let { compType } = this.info;
        // console.log(compType)
        if (compType === "editor") {
            return h("div", {
                class: ["editor_con"],
                domProps: {
                    innerHTML: this.value
                },
            })
        } else if (compType === "rate") {
            return h(this.info.ele, {
                props: {
                    value: this.value,
                    allowHalf: true
                }
            })
        }

        else if (compType === "alert") {
            return h(this.info.ele, {
                props: {
                    ...this.info,

                }
            })
        }

        else if (compType === "button") {
            return h(this.info.ele, {
                props: {
                    ...this.info,


                }
            }, this.info.text)
        }
        else if (compType === "barCode") {
            return h(this.info.ele, {
                props: {
                    ...this.info,
                    width: 2

                }
            })
        } else if (compType == "link") {
            return h(this.info.ele, {
                props: {
                    ...this.info,
                },
                attrs: {
                    target: "parent"
                }
            }, [
                h("span", this.info.text)
            ])
        } else if (compType === "text") {
            return h(this.info.ele, {
                props: {
                    ...this.info,
                }
            }, [
                h("FancyText", {
                    props: {
                        ...this.info,

                    }
                })
            ])
        } else if (compType == "upload") {
            return h("FileList", {
                props: {
                    "list-type": this.info["list-type"],
                    value: this.value ? JSON.parse(this.value) : []

                }
            })
        } else if (compType == "dynamicTable") {
            let tr = this.info.columns.map((item) => {
                return h("el-table-column", {
                    props: {
                        prop: item.id,
                        label: item.label,
                        formatter: (row, column, cellValue, index) => {
                            return h("div", getShowValue(item, row[item.id]))

                        }
                    }
                })
            });
            if (this.info.showIndex) {
                tr.unshift(h("el-table-column", {
                    props: {
                        prop: "data_index",
                        label: "序号",
                        align: "center",
                        width: 50,
                        formatter: (row, column, cellValue, index) => {
                            return h("div", index + 1)

                        }
                    }
                }));
            };
            return h("el-table", {
                props: {
                    data: this.value,
                    size: "small"

                }
            }, tr)
        } else {

            return h("div", getShowValue(this.info, this.value))
        }

    }
};






const plugins = {
    install: function (Vue) {
        Vue.component("ValueRender", ValueRender);
        Vue.component("FancyText", FancyText);
        Vue.component("FileList", FileList);
    }
}

// 这一步判断window.Vue是否存在，因为直接引用vue.min.js， 它会把Vue绑到Window上，我们直接引用打包好的js才能正常跑起来。
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugins);
}


export default plugins;